import { DEMO_1_FEMALE_EMAIL, DEMO_2_MALE_EMAIL } from "./demo-users";
import { useCurrentUser } from "../authentication/user/current-user";

const DEMO_USERS = [DEMO_2_MALE_EMAIL, DEMO_1_FEMALE_EMAIL];

export function useIsDemoExperience() {
  const { data: user } = useCurrentUser();

  return DEMO_USERS.includes(user?.email ?? "");
}
